import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/user';
import Dropzone from "react-dropzone";
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { validateEmail } from '../../utils/misc';
import Dialog from 'material-ui/Dialog';
import Avatar from 'material-ui/Avatar';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import { Card, CardActions, CardHeader, CardTitle, CardText } from 'material-ui/Card';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import {
    CHANGE_PASSWORD_SUCCESS,
    DELETE_FILE_SUCCESS,
    DOWNLOAD_FILE_SUCCESS,
    VIEW_USER_SUCCESS,
    UPLOAD_USER_FILE_SUCCESS,
    UPDATE_USER_SUCCESS,
} from '../../constants';


function mapStateToProps(state) {
    return {
        data: state.user.user,
        files: state.user.files,
        token: state.auth.token,
        url: state.user.url,
        isLoading: state.user.isFetching,
        isUploading: state.user.isUploading,
        action: state.user.action,
        statusText: state.auth.statusText,
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

let dropzoneRef;

@connect(mapStateToProps, mapDispatchToProps)
export default class UserView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isUploading: false,
            updateFormStateOpen: false,
            passwordFormStateOpen: false,
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            role_id: null,
            disabled: false,
            disabledPass: false,
            first_name_error_text: null,
            last_name_error_text: null,
            email_error_text: null,
            role_erroer_text: null,
            password_error_text: null,
            sucess_txt: '',
        };
    }

    componentDidMount() {
        this.fetchUser(this.props.location.state.userId);
        this.fetchFiles(this.props.location.state.userId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action === VIEW_USER_SUCCESS) {
            this.setState({
                email: nextProps.data.email,
                first_name: nextProps.data.first_name,
                last_name: nextProps.data.last_name,
                role_id: nextProps.data.role.id
            });
        }
        if (nextProps.action === UPLOAD_USER_FILE_SUCCESS || nextProps.action === DELETE_FILE_SUCCESS) {
            this.fetchFiles(this.props.location.state.userId);
        }

        if (nextProps.action === DOWNLOAD_FILE_SUCCESS) {
            setTimeout(() => {
                location.href = this.props.url;
            }, 100);
        }

        if (nextProps.action === UPDATE_USER_SUCCESS) {
            this.fetchUser(this.props.location.state.userId);
            this.handleUpdateFormClose()
        }

        if (nextProps.action === CHANGE_PASSWORD_SUCCESS) {
            this.handlePasswordFormClose()
        }
    }

    isDisabled() {
        let email_is_valid = false;

        //email check
        if (this.state.email === '') {
            this.setState({
                email_error_text: null,
            });
        } else if (validateEmail(this.state.email)) {
            email_is_valid = true;
            this.setState({
                email_error_text: null,
            });

        } else {
            this.setState({
                email_error_text: 'Sorry, this is not a valid email',
            });
        }

        if (email_is_valid) {
            this.setState({
                disabled: false,
            });
        }
    }

    isPassDisabled() {
        let password_is_valid = false;
        //password chehck
        if (this.state.password === '' || !this.state.password) {
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.password.length >= 6) {
            password_is_valid = true;
            this.setState({
                password_error_text: null,
            });
        } else {
            this.setState({
                password_error_text: 'Your password must be at least 6 characters',
            });
        }

        if (password_is_valid) {
            this.setState({
                disabledPass: false,
            });
        }
    }

    fetchUser(id) {
        const token = this.props.token;
        this.props.viewUser(id, token);
    }

    fetchFiles(id) {
        const token = this.props.token;
        this.props.viewUserFiles(id, token);
    }

    onDrop = (files) => {
        const token = this.props.token;
        const id = this.props.location.state.userId;
        this.props.uploadUserFile(id, files[0], token);
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            if (!this.state.disabled) {
                this.updateUser(e)
            }
        }
    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isDisabled();
        });
    }

    changePassValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isPassDisabled();
        });
    }

    handleSelectChange = (event, index, value) => {
        this.setState({ role_id: value });
    }

    handleUpdateFormOpen = () => {
        this.setState({ updateFormStateOpen: true });
    };

    handleUpdateFormClose = () => {
        this.setState({ updateFormStateOpen: false });
    };

    handlePasswordFormOpen = () => {
        this.setState({ passwordFormStateOpen: true });
    };

    handlePasswordFormClose = () => {
        this.setState({ passwordFormStateOpen: false });
    };

    downloadFile(e, id) {
        e.preventDefault();
        this.props.downloadFile(id, this.props.token)
    }

    deleteFile(e, id) {
        e.preventDefault();
        this.props.deleteFile(id, this.props.token)
    }

    updateUser(e) {
        e.preventDefault();
        const user = {
            email: this.state.email,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            role_id: this.state.role_id,
        };
        this.props.updateUser(this.props.data.id, user, this.props.token)
    }

    updatePass(e) {
        e.preventDefault();
        this.props.changePass(this.props.data.id, '', this.state.password, this.props.token)
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleUpdateFormClose}
            />,
            <FlatButton
                label="Update"
                primary={true}
                disabled={this.state.disabled}
                onClick={(e) => this.updateUser(e)}
            />,
        ];
        const actionsPass = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handlePasswordFormClose}
            />,
            <FlatButton
                label="Change"
                primary={true}
                disabled={this.state.disabled}
                onClick={(e) => this.updatePass(e)}
            />,
        ];

        return (
            <div className="container">
                {this.props.data ?
                    <div className="row">
                        <Card>
                            <CardHeader
                                title={'' + this.props.data.first_name + ' ' + this.props.data.last_name}
                                subtitle={this.props.data.username}
                                avatar={<Avatar>{this.props.data.first_name.charAt(0)}</Avatar>}
                            />
                            <CardText>
                                <div className="row">
                                    <div className="col-md-1">
                                        <RaisedButton label="Update" primary={true} onClick={(e) => this.handleUpdateFormOpen()} />
                                    </div>
                                    <div className="col-md-4"style={{marginLeft: 20}}>
                                        <RaisedButton label="Change Password" primary={true} onClick={(e) => this.handlePasswordFormOpen()} />
                                    </div>
                                </div>
                            </CardText>
                            {this.props.data.role !== undefined && this.props.data.role.name !== 'SUPER_ADMIN' ?
                                <CardTitle title="Files" />
                                : ''}
                            {this.props.data.role !== undefined && this.props.data.role.name !== 'SUPER_ADMIN' ?
                                <CardText>
                                    <Table>
                                        <TableHeader
                                            displaySelectAll={false}
                                            adjustForCheckbox={false}>
                                            <TableRow>
                                                <TableHeaderColumn>ID</TableHeaderColumn>
                                                <TableHeaderColumn>Name</TableHeaderColumn>
                                                <TableHeaderColumn>Path</TableHeaderColumn>
                                                <TableHeaderColumn></TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody displayRowCheckbox={false}>
                                            {this.props.files && this.props.files.map(row => {
                                                return (
                                                    <TableRow key={row.id}>
                                                        <TableRowColumn>{row.id}</TableRowColumn>
                                                        <TableRowColumn>{row.name}</TableRowColumn>
                                                        <TableRowColumn>{row.path}</TableRowColumn>
                                                        <TableRowColumn>
                                                            <FlatButton label="Download" onClick={(e) => this.downloadFile(e, row.id)} />
                                                            <FlatButton label="Delete" onClick={(e) => this.deleteFile(e, row.id)} />
                                                        </TableRowColumn>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </CardText>
                                : ''}
                            {this.props.data.role !== undefined && this.props.data.role.name !== 'SUPER_ADMIN' ?
                                <CardActions>
                                    {this.props.isUploading ? <h3>Uploading...</h3> : ''}
                                    <RaisedButton label="Upload File" disabled={this.state.isUploading} primary={true} onClick={() => { dropzoneRef.open() }} />

                                    <section>
                                        <div >
                                            <Dropzone className="container-fluid" onDrop={(files) => this.onDrop(files)} ref={(node) => { dropzoneRef = node; }} />
                                        </div>
                                    </section>
                                </CardActions>
                                : ''}
                        </Card>
                        <Dialog
                            title="Update User"
                            actions={actions}
                            modal={true}
                            open={this.state.updateFormStateOpen}
                        >
                            <div className="col-md-6 col-md-offset-3" onKeyPress={(e) => this._handleKeyPress(e)}>
                                <form role="form">
                                    <div className="text-center">
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="First Name"
                                                floatingLabelText="First Name"
                                                type="text"
                                                defaultValue={this.state.first_name}
                                                errorText={this.state.first_name_error_text}
                                                onChange={(e) => this.changeValue(e, 'first_name')}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="Last Name"
                                                floatingLabelText="Last Name"
                                                type="text"
                                                defaultValue={this.state.last_name}
                                                errorText={this.state.last_name_error_text}
                                                onChange={(e) => this.changeValue(e, 'last_name')}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="Email"
                                                floatingLabelText="Email"
                                                type="email"
                                                defaultValue={this.state.email}
                                                errorText={this.state.email_error_text}
                                                onChange={(e) => this.changeValue(e, 'email')}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <SelectField
                                                floatingLabelText="Role"
                                                value={this.state.role_id}
                                                onChange={this.handleSelectChange}
                                            >
                                                <MenuItem value={1} primaryText="Admin" />
                                                <MenuItem value={2} primaryText="Client" />
                                            </SelectField>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Dialog>
                        <Dialog
                            title="Change Password"
                            actions={actionsPass}
                            modal={true}
                            open={this.state.passwordFormStateOpen}
                        >
                            <div className="col-md-6 col-md-offset-3">
                                <form role="form">
                                    <div className="text-center">
                                        <div className="col-md-12">
                                            <TextField
                                                hintText="Password"
                                                floatingLabelText="Password"
                                                type="password"
                                                errorText={this.state.password_error_text}
                                                onChange={(e) => this.changePassValue(e, 'password')}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Dialog>
                    </div>
                    : ''}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/UserView.js